import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UsersService } from '../../../services/users.service';
import { Observable, endWith, finalize, map } from 'rxjs';
import { AddOrRemoveRolesToUserRequest, UserRoleDTO } from '../../../interfaces/user.interface';
import { SelectionModel } from '@angular/cdk/collections';
import Swal from 'sweetalert2';
import { RoleSummaryDTO } from '../../../interfaces/roles.interfaces';
import { RolesService } from '../../../services/roles.service';

@Component({
  selector: 'app-user-roles-management',
  templateUrl: './user-roles-management.component.html',
  styleUrls: ['./user-roles-management.component.scss']
})
export class UserRolesManagementComponent implements OnInit {
  @Input() public userId: string;
  @Output() notify: EventEmitter<string> = new EventEmitter();
  public roles$: Observable<Array<RoleSummaryDTO>>;
  public userRoles : Array<UserRoleDTO>;
  public displayedColumns = [
    'selection',
    'name'
  ]
  public loading: boolean = false;

  intUserId: number;

  public showAssignRoleSection: boolean = false;

  public rolesSelection = new SelectionModel<UserRoleDTO>(true, [], false, (r1, r2) => r1.roleId === r2.roleId);

  constructor(private userService: UsersService, private roleService: RolesService){
    this.userRoles = new Array<UserRoleDTO>;
    this.roles$ = new Observable<Array<RoleSummaryDTO>>;
  }

  ngOnInit(): void {
    const rutNum = this.userId.split('-')[0] ||'';
    const userId = Number.parseInt(rutNum);
    this.intUserId = userId;
    this.getDetail();
    this.getAllRoles();
  }

  getDetail(){
    if(!this.userId) return;
    const rutNum = this.userId.split('-')[0] ||'';
    const userId = Number.parseInt(rutNum);
    this.loading = true;
    this.userService.getUserById(userId)
    .pipe(
      map(res => {
        return res.roles
      }),
      finalize(() => this.loading = false)
    ).subscribe({
      next: (roles) =>{
        this.userRoles = roles
      }
    });
  }

  getAllRoles(){
    this.roles$ = this.roleService.getAllRoles();
  }


  isAllSelected(): boolean {
    const selected = this.rolesSelection.selected.length;
    const numRows = this.userRoles.length;
    return numRows === selected;
  }

  toggleAll(){
    if(this.isAllSelected()){
      this.rolesSelection.clear();
      return;
    }
    this.rolesSelection.select(...this.userRoles);
  }

  clickRemoveSelectedUserRoles() {
    const request: AddOrRemoveRolesToUserRequest = {
      userId: this.intUserId,
      rolesId: this.rolesSelection.selected.map(r => r.roleId)
    };
    Swal.fire({
      title: 'Quitando roles',
      icon: 'info',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        this.sendRemoveUserRolesRequest(request);
      }
    })
  }

  sendRemoveUserRolesRequest(request: AddOrRemoveRolesToUserRequest) {
    this.userService.removeRolesToUser(request)
    .subscribe({
      next:(response) => {
        Swal.fire({
          text: response.resultMessage,
          allowOutsideClick: false,
          icon: 'success',
          confirmButtonText: 'Ok'
        }).then((r) => {
          this.getDetail();
          this.rolesSelection.clear();
          this.notify.emit("Notificando");
        })
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: err.error.resultMessage,
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar',
        })
      }
    })
  }

  clickAssignRolesToUser(){
    this.showAssignRoleSection = true;
  }

  receiveRolesToAssign(rolesId: Array<number> | null){
    if(!rolesId){
      this.showAssignRoleSection = false;
      return;
    } 
    const request: AddOrRemoveRolesToUserRequest = {
      userId: this.intUserId,
      rolesId: rolesId,
    };
    Swal.fire({
      title: 'Asignando nuevos roles',
      icon: 'info',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        this.sendAssignUserRoles(request);
      }
    })

  }

  sendAssignUserRoles(request: AddOrRemoveRolesToUserRequest){
    this.userService.assignRolesToUser(request)
    .subscribe({
      next:(response) => {
        Swal.fire({
          text: response.resultMessage,
          allowOutsideClick: false,
          icon: 'success',
          confirmButtonText: 'Ok'
        }).then((r) => {
          this.getDetail();
          this.showAssignRoleSection = false;
          this.rolesSelection.clear();
          this.notify.emit("Notificando");
        });
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: err.error.resultMessage,
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar',
        });
      }
    });
  }

}
